// 文章 常見問題問答 Faq
const NewsFaq = ({ t, faqTopic }) => {
  return (
    <div className="text-black space-y-[20px]">
      <p className="text-h2">
        {faqTopic?.title}
        {t("FAQ")}
      </p>
      {faqTopic?.faqList?.map((faq, i) => (
        <div key={i + "faq" + i} className="space-y-[20px]">
          <p className="text-h3">{faq?.question}</p>
          <p className="text-bd2n font-[300]">{faq?.answer}</p>
        </div>
      ))}
    </div>
  );
};

export default NewsFaq;
